var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTickPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "16px",
    viewBox: "0 0 19 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Forms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form-/-Check-Box---Selected",
    transform: "translate(-7.000000, -9.000000)",
    stroke: "#004BB9",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    points: "9 16.2200944 14.0189517 21.5 24 11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickPrimary);
export default __webpack_public_path__ + "static/media/icon-tick--primary.b40bc8e4bc4f61c25f6dc20c0754d3f3.svg";
export { ForwardRef as ReactComponent };